module.exports = __webpack_public_path__ + "img/vladiyan1.6107a8e3.png";